import React from 'react'

import { SlideFrame } from './SlideFrame'
import type { SlideFrameProps } from './SlideFrame'
import { presetSlot, presetSlots } from './presetSlots'

/**
 * The `stage` layout (plots plan Stage 2, AF): `SlideFrame`'s flow (header, a
 * full-width headline and subtitle, then the body), with the headline's line budgets
 * the preset binds (`layouts/stage.json` plus the preset's overrides) instead of one
 * budget for every slide.
 */
export interface StageLayoutProps extends Omit<SlideFrameProps, 'headlineMaxLines' | 'fullBleed'> {
  /** The slide type, which names its bound slots. */
  preset: string
  /** Replaces the line budgets read from the preset's bound slots. */
  headlineMaxLines?: { title: number; subtitle?: number }
}

export function StageLayout({ preset, headlineMaxLines, ...frame }: StageLayoutProps) {
  const boundHeadlineMaxLines = {
    title: presetSlot(preset, 'headline').text!.maxLines,
    // A preset that draws no subtitle (podium) binds no narrative slot.
    subtitle: presetSlots(preset).narrative?.text?.maxLines,
  }
  return <SlideFrame {...frame} headlineMaxLines={headlineMaxLines ?? boundHeadlineMaxLines} />
}
